export interface LoadingState {
  loading: boolean
}

export enum LoadTypes {
  SET_LOADING_ACTIVE = '@loading/SET_LOADING_ACTIVE',
  SET_LOADING_INACTIVE = '@loading/SET_LOADING_INACTIVE',
}
